// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAIrTg08565O7zxmvniBkNp5RTea9e0sF8",
  authDomain: "roleplayapp-f46be.firebaseapp.com",
  databaseURL: "https://roleplayapp-f46be-default-rtdb.firebaseio.com",
  projectId: "roleplayapp-f46be",
  storageBucket: "roleplayapp-f46be.appspot.com",
  messagingSenderId: "196424435705",
  appId: "1:196424435705:web:1743a1d5c055ea90a89f28",
  measurementId: "G-N7HS6CH74Z",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
